module.exports = __webpack_public_path__ + "img/ag.e09a9c37.png";